import ApplyMode from "@/model/apply/ApplyMode"

const StepMode = {
    FULL: "full",
    FULL_JOINT: "fullJoint",
    PREQUALIFY: "prequalify",
    PRESCREEN: "prescreen",
    NO_OFFER: "noOffer",
}

export function fromPrimaryLenderApplyMode(primaryLenderApplyMode) {
    switch (primaryLenderApplyMode) {
        case ApplyMode.FULL: return StepMode.FULL
        case ApplyMode.PREQUALIFY: return StepMode.PREQUALIFY
        case ApplyMode.PRESCREEN: return StepMode.PRESCREEN
        default: return null
    }
}

export default StepMode
